/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { AuthRoles } from 'jotai/auth';
import { authService } from 'services/auth/AuthService';

const isFormulaOneUser = () => {
  const userRoles = authService.getRolesAllRealms();
  const authorizedF1Roles: string[] = [AuthRoles.ADMIN, AuthRoles.F1];
  return userRoles && userRoles?.some((item) => authorizedF1Roles.includes(item));
};

export default isFormulaOneUser;
